import styled from 'styled-components'

export const DiscountSectionWrapper = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 1000px;
`

export const SectionTitle = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 10px;
`

export const DiscountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
`

export const DiscountLabel = styled.span`
  font-weight: 500;
  min-width: 80px;
`

export const DollarSymbol = styled.span`
  font-weight: 500;
`

export const PercentSymbol = styled.span`
  font-weight: 500;
`

export const AddButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`

export const DiscountCard = styled.div`
  background-color: #f9fafb;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  font-family: 'Inter', sans-serif;
  max-width: 400px;
`

export const DiscountLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
`

export const DiscountLabelStyled = styled.span`
  font-weight: 600;
  color: #374151;
  font-size: 14px;
`

export const DiscountValue = styled.span`
  font-weight: 500;
  background-color: #e0f2f1;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 13px;
  color: #00695c;
`

export const DiscountFormula = styled.span`
  font-size: 13px;
  color: #6b7280;
`

export const DiscountEquals = styled.span`
  font-size: 13px;
  margin: 0 6px;
  color: #6b7280;
`

export const DiscountTotal = styled.span`
  font-weight: bold;
  font-size: 15px;
  color: #1e40af;
`
